<template>
  <div class="intelligent-security">
    <div id="popular">
      <div class="none">
        <div class="a" onclick="toggle()"></div>
        <h1>资料下载</h1>
        <table>
          <tr>
            <th>文件名称</th>
            <th>文件格式</th>
            <th>文件大小</th>
            <th>操作</th>
          </tr>
          <tr v-for="(person, index) in arr" :key="index">
            <td>
              <div>{{ person.fileName }}</div>
            </td>
            <td>
              <div>{{ person.fileFormat }}</div>
            </td>
            <td>
              <div>{{ person.fileSize }}</div>
            </td>
            <td>
              <img
                @click="download(person.url, person.fileName)"
                src="../assets/img/buliding/icon_download.png"
                alt=""
              />
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div id="acc"></div>

    <div id="blur">
      <header>
        <div class="main">
          <div class="banner"></div>

          <div class="left"></div>

          <div class="right"></div>
        </div>
      </header>

      <main>
        <div class="main">
          <div class="main-background1"></div>
          <div class="main-background2"></div>
          <div class="main-background3"></div>
          <div class="left"></div>
          <div class="center">
            <div class="main1">
              <div class="main1-background">SMART</div>
              <h1>道路监控</h1>
              <p>
                般极活性济众己率况八史次等较音与县断青话号选子次成流加约元派产王日线消精军知比口门对每眼形过政保经同改金特极近那性京段元物土机亲气细调治。次设接广四物飞还心时严业整面研东量意直织省社立日号当把直传度决次取但提深非。究心意包四据张证总别斯热非习易土没业识反气没各书明是级合。
              </p>
            </div>

            <div class="main2">
              <div class="main2Center">
                <div class="dimg1">
                  <img
                    src="../assets/img/download2/智能安防_下载资源1@2x.png"
                    alt=""
                  />
                </div>
                <div class="main-text">
                  <h1>道路监控</h1>
                  <p>
                    智能安防系统可以简单理解为：图像的传输和存储、数据的存储和处理准确而选择性操作的技术系统。就智能化安防系统来说，一个完整的智能安防系统主要包括门禁、报警和监控三大部分。
                  </p>
                </div>
              </div>
            </div>

            <div class="main3">
              <div class="dimg2">
                <img
                  src="../assets/img/download2/智能安防_下载资源2@2x.png"
                  alt=""
                />
              </div>
              <div class="main-text">
                <h1>道路监控</h1>
                <p>
                  智能安防系统可以简单理解为：图像的传输和存储、数据的存储和处理准确而选择性操作的技术系统。就智能化安防系统来说，一个完整的智能安防系统主要包括门禁、报警和监控三大部分。
                </p>
              </div>
            </div>

            <div class="main4">
              <div class="main4-left">
                <div class="main-text">
                  <h1>道路监控</h1>
                  <p>
                    智能安防系统可以简单理解为：图像的传输和存储、数据的存储和处理准确而选择性操作的技术系统。就智能化安防系统来说，一个完整的智能安防系统主要包括门禁、报警和监控三大部分。
                  </p>
                </div>
                <p class="p">
                  联系电话：0755-83932176<i
                    >地址：深圳市盐田区沙头角深盐路保发大厦5楼整层</i
                  >
                </p>
                <button onclick="toggle()">
                  下载资料<img
                    src="../assets/img/download2/icon_more@2x.png"
                    alt=""
                  />
                </button>
              </div>
              <div class="dimg3">
                <img
                  src="../assets/img/download2/智能安防_下载资源3@2x.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class="right"></div>
        </div>
      </main>
    </div>

    <Footer></Footer>
  </div>
</template>
<script>
import Footer from "../components/footer.vue";
export default {
  components: { Footer },
  name: "traffic2",
  data() {
    return {
      arr: []
    };
  },
  created() {
    window.toggle = this.toggle;
  },
  mounted() {
    this.toggle2();
  },
  methods: {
    toggle() {
      var blur = document.getElementById("blur");
      blur.classList.toggle("active");
      var acc = document.getElementById("acc");
      acc.classList.toggle("active");
      var popular = document.getElementById("popular");
      popular.classList.toggle("active");
    },
    toggle2() {
      this.request.get("/information/3", {}).then(res => {
        this.arr = res.data.data;
      });
    },

    download(url, fileName) {
      // let a=document.createElement('a')
      // a.style.display='none'
      // a.href=url
      // document.body.appendChild(a)
      // a.click()
      // document.body.removeChild(a)

      // const blobUrl = window.URL.createObjectURL(url);
      // const a = document.createElement('a');
      // a.href = blobUrl;
      // a.download = fileName;
      // a.click();
      // window.URL.revokeObjectURL(url);

      // const element = document.createElement('a');
      // element.setAttribute('download', fileName);
      // let binaryData = [];
      // binaryData.push(url);
      // element.setAttribute('href', window.URL.createObjectURL(new Blob(binaryData)));
      // document.body.appendChild(element);
      // element.click();
      // document.body.removeChild(element);

      window.open("https://www.szce.com/api/common/download/" + fileName);
      // window.open(url);
    }
  }
};
</script>
<!-- <style scoped>
.main2Center {
  width: 1260px;
  margin: 0 auto;
}

header {
  height: 230px;
}
header .banner {
  background: url(../assets/img/download2/智能安防_下载资源_banner@2x.png)
    no-repeat;
  background-size: 100% 100%;
}
#blur.active {
  pointer-events: none;
  user-select: none;
}
#acc.active {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.77);
  z-index: 998;
}
#popular {
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 1200px;
  height: 600px;
  z-index: 999;
  visibility: hidden;
  opacity: 0;
  transition: 0.5s;
}
#popular .none {
  position: relative;
  width: 1200px;
  height: 100%;
  background-color: white;
  padding: 20.0064px 39.9936px 0 20.0064px;
}
.none .a {
  position: absolute;
  right: -56px;
  top: -16px;
  display: block;
  width: 32px;
  height: 32px;
  cursor: pointer;
  background: url(../assets//img/case/icon_close@2x.png) no-repeat;
  background-size: 100% 100%;
}
.none h1 {
  margin-bottom: 20.0064px;
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.58);
  line-height: 24px;
}
.none table {
  border-collapse: collapse;
  width: 100%;
}
td,
th {
  border-bottom: 0.9984px solid #000000;
  text-align: left;
  padding: 16px 100px;
}
th {
  color: rgba(0, 0, 0, 0.58);
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
}
td {
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.44);
  line-height: 22px;
}
#popular.active {
  top: 45%;
  visibility: visible;
  opacity: 1;
  transition: 0.5s;
}
main {
  position: relative;
}
.main-background1 {
  position: absolute;
  top: 667px;
  width: 100%;
  height: 326px;
  background: #f5f6fb;
  z-index: -1;
}
.main-background2 {
  position: absolute;
  top: 1133px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 707px;
  height: 536px;
  background: #f5f6fb;
  z-index: -1;
}
.main-background3 {
  position: absolute;
  top: 1806px;
  width: 100%;
  height: 520px;
  background: #f5f6fb;
  z-index: -1;
}
.main1 {
  width: 1260px;
  left: 50%;
  position: relative;
  margin-left: -630px;
  height: 515px;
}
.main1-background {
  position: absolute;
  top: 144px;
  left: 50%;
  transform: translate(-50%, 0);
  font-size: 163px;
  font-weight: normal;
  color: #fafafa;
  line-height: 187px;
  letter-spacing: 6px;
  z-index: -1;
}
.main1 h1 {
  position: absolute;
  top: 206px;
  left: 50%;
  transform: translate(-50%, 10px);
  font-size: 31px;
  color: #140047;
  line-height: 33px;
  letter-spacing: 1.92px;
  text-align: center;
}
.main1 p {
  position: absolute;
  display: block;
  width: 1024px;
  left: 50%;
  margin-left: -517px;
  top: 275px;
  height: 77px;
  text-align: center;
  font-size: 13px;
  font-weight: 400;
  color: #01021b;
  line-height: 33px;
  letter-spacing: 0.96px;
}

@media screen and (max-width: 1260px) {
  body .main2 .main-text {
    margin-left: -150px;
  }
  body .main2 .dimg1 {
    width: 100%;
  }
}

@media screen and (max-width: 1060px) {
  #popular .none {
    transform: scale(0.6);
  }
}
@media screen and (max-width: 1260px) and (min-width: 1060px) {
  #popular .none {
    transform: scale(0.7);
  }
}
@media screen and (max-width: 1360px) and (min-width: 1260px) {
  #popular .none {
    transform: scale(0.8);
  }
}

.main2 {
  position: relative;
  display: flex;
  justify-content: flex-end;
  margin-top: 161px;
  height: 578px;
}
.main2 .main-text {
  position: absolute;
  padding: 44px;
  width: 634px;
  height: 259px;
  top: -75px;
  left: 50%;
  margin-left: 100px;
}
.main2 .main-text h1 {
  font-size: 31px;
  font-family: AlibabaPuHuiTiB;
  color: #140047;
  line-height: 42px;
  letter-spacing: 2px;
}
.main-text {
  padding: 40px;
  /* height: 319px; */
  background: #ffffff;
  box-shadow: 0rem 0.9984px 10px 0rem rgba(176, 183, 213, 0.2);
}
.main-text h1 {
  margin-bottom: 27px;
  font-size: 38px;
  color: #140047;
  line-height: 52px;
  letter-spacing: 1.92px;
}
.main-text p {
  font-size: 16px;
  font-weight: 400;
  color: #01021b;
  line-height: 40px;
  letter-spacing: 0.96px;
}
.main3 {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-top: 70px;
}
.main3 img {
  margin-right: 44px;
  width: 720px;
  height: 566px;
}
.main4 {
  margin-top: 112px;
  display: flex;
  width: 100%;
  justify-content: center;
}
.main4 img {
  margin-left: 44px;
  width: 720px;
  height: 566px;
}
.main4-left .p {
  margin: 32px 0;
  font-size: 16px;
  font-weight: 500;
  color: #140047;
  line-height: 28px;
  letter-spacing: 0.96px;
  opacity: 1;
}
.main4-left .p i {
  margin-left: 26px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #140047;
  line-height: 23px;
  letter-spacing: 1px;
}
.main4-left button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  height: 52px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  border: 0.96px solid #140047;
  font-size: 18px;
  font-weight: 600;
  color: #140047;
  line-height: 24px;
  cursor: pointer;
  transition: all 0.3s;
}
.main4-left button img {
  width: 18px;
  height: 10px;
  margin-left: 40px;
}
button:hover {
  margin-left: 30.0096px;
}
.dimg1 {
  width: 1196px;
  height: 470px;
}
.dimg1 img {
  width: 100%;
  height: 100%;
}
.dimg2 {
  width: 611px;
  height: 486px;
  margin-right: 36px;
}
.dimg2 img {
  width: 100%;
  height: 100%;
}

.main3 .main-text {
  width: 634px;
  /* height:259px; */
}
.main4 .main-text {
  width: 634px;
  height: 259px;
}
.dimg3 {
  width: 611px;
  height: 475px;
  margin-top: 12px;
}
.dimg3 img {
  width: 100%;
  height: 100%;
}
img {
  border: 1px dashed #808080;
}
p {
  opacity: 0.72;
}
</style> -->

<style scoped>
.main2Center {
  width: 1260px;
  margin: 0 auto;
}

header {
  height: 230px;
}
header .banner {
  background: url(../assets/img/download2/智能安防_下载资源_banner@2x.png)
    no-repeat center;
  background-position: 100%;
  background-size: cover;
}
@media screen and (max-width: 1060px) {
  #popular .none {
    transform: scale(0.6);
  }
}
@media screen and (max-width: 1260px) and (min-width: 1060px) {
  #popular .none {
    transform: scale(0.7);
  }
}
@media screen and (max-width: 1360px) and (min-width: 1260px) {
  #popular .none {
    transform: scale(0.8);
  }
}

@media screen and (max-width: 1260px) {
  body .main2 .main-text {
    margin-left: -150px;
  }
  body .main2 .dimg1 {
    width: 100%;
  }
}
.main2Center {
  width: 1260px;
  margin: 0 auto;
}

header {
  /* height: 187px; */
  height: 230px;
}

#blur.active {
  pointer-events: none;
  user-select: none;
}
#acc.active {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.77);
  z-index: 998;
}
#popular {
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 1200px;
  height: 600px;
  z-index: 999;
  visibility: hidden;
  opacity: 0;
  transition: 0.5s;
}
#popular .none {
  position: relative;
  width: 1200px;
  height: 100%;
  background-color: white;
  padding: 20.0064px 39.9936px 0 20.0064px;
}
.none .a {
  position: absolute;
  right: -56px;
  top: -16px;
  display: block;
  width: 32px;
  height: 32px;
  cursor: pointer;
  background: url(../assets//img/case/icon_close@2x.png) no-repeat;
  background-size: 100% 100%;
}
.none h1 {
  margin-bottom: 20.0064px;
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.58);
  line-height: 24px;
}
.none table {
  border-collapse: collapse;
  width: 100%;
}
td,
th {
  border-bottom: 0.9984px solid #000000;
  text-align: left;
  padding: 16px 83px;
  white-space: nowrap;
}
th {
  color: rgba(0, 0, 0, 0.58);
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
}
td {
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.44);
  line-height: 22px;
}
#popular.active {
  top: 45%;
  visibility: visible;
  opacity: 1;
  transition: 0.5s;
}
main {
  position: relative;
}
.main-background1 {
  position: absolute;
  top: 667px;
  width: 100%;
  /* left:50%;
  margin-left:-780px; */
  height: 326px;
  background: #f5f6fb;
  z-index: -1;
}
.main-background2 {
  position: absolute;
  top: 1133px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 707px;
  height: 536px;
  background: #f5f6fb;
  z-index: -1;
}
.main-background3 {
  position: absolute;
  top: 1806px;
  width: 100%;
  /* left:50%;
  margin-left:-780px; */
  height: 520px;
  background: #f5f6fb;
  z-index: -1;
}
.main1 {
  width: 1260px;
  left: 50%;
  position: relative;
  margin-left: -630px;
  height: 434px;
}
.main1-background {
  position: absolute;
  top: 144px;
  left: 50%;
  transform: translate(-50%, 0);
  font-size: 163px;
  font-weight: normal;
  color: #fafafa;
  line-height: 187px;
  letter-spacing: 6px;
  z-index: -1;
}
.main1 h1 {
  position: absolute;
  top: 206px;
  left: 50%;
  transform: translate(-50%, 10px);
  font-size: 31px;
  color: #140047;
  line-height: 33px;
  letter-spacing: 1.92px;
  text-align: center;
}
.main1 p {
  position: absolute;
  display: block;
  width: 1024px;
  left: 50%;
  margin-left: -517px;
  top: 275px;
  height: 77px;
  text-align: center;
  font-size: 13px;
  font-weight: 400;
  color: #01021b;
  line-height: 33px;
  letter-spacing: 0.96px;
}
.main2 {
  position: relative;
  display: flex;
  justify-content: flex-end;
  margin-top: 161px;
  height: 578px;
}
.main2 .main-text {
  position: absolute;
  padding: 44px;
  width: 634px;
  height: 259px;
  top: -75px;
  left: 50%;
  margin-left: 100px;
}
.main2 .main-text h1 {
  font-size: 31px;
  font-family: AlibabaPuHuiTiB;
  color: #140047;
  line-height: 42px;
  letter-spacing: 2px;
}
.main-text {
  padding: 40px;
  /* height: 319px; */
  background: #ffffff;
  box-shadow: 0rem 0.9984px 10px 0rem rgba(176, 183, 213, 0.2);
}
.main-text h1 {
  margin-bottom: 27px;
  font-size: 38px;
  color: #140047;
  line-height: 52px;
  letter-spacing: 1.92px;
}
.main-text p {
  font-size: 16px;
  font-weight: 400;
  color: #01021b;
  line-height: 40px;
  letter-spacing: 0.96px;
}
.main3 {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-top: 70px;
}
.main3 img {
  margin-right: 44px;
  width: 720px;
  height: 566px;
}
.main4 {
  margin-top: 112px;
  display: flex;
  width: 100%;
  justify-content: center;
}
.main4 img {
  margin-left: 44px;
  width: 720px;
  height: 566px;
}
.main4-left .p {
  margin: 32px 0;
  font-size: 16px;
  font-weight: 500;
  color: #140047;
  line-height: 28px;
  letter-spacing: 0.96px;
  opacity: 1;
}
.main4-left .p i {
  margin-left: 26px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #140047;
  line-height: 23px;
  letter-spacing: 1px;
}
.main4-left button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  height: 52px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  border: 0.96px solid #140047;
  font-size: 18px;
  font-weight: 600;
  color: #140047;
  line-height: 24px;
  cursor: pointer;
  transition: all 0.3s;
}
.main4-left button img {
  width: 18px;
  height: 10px;
  margin-left: 40px;
}
button:hover {
  margin-left: 30.0096px;
}
.dimg1 {
  width: 1196px;
  height: 470px;
}
.dimg1 img {
  width: 100%;
  height: 100%;
}
.dimg2 {
  width: 611px;
  height: 486px;
  margin-right: 36px;
}
.dimg2 img {
  width: 100%;
  height: 100%;
}

.main3 .main-text {
  width: 634px;
  /* height:259px; */
}
.main4 .main-text {
  width: 634px;
  height: 259px;
}
.dimg3 {
  width: 611px;
  height: 475px;
  /* margin-top: 12px; */
  margin-top: -12px;
  padding-bottom: 30px;
}
.dimg3 img {
  width: 100%;
  height: 100%;
}
img {
  border: 1px dashed #808080;
}
p {
  opacity: 0.72;
}
</style>



// WEBPACK FOOTER //
// src/components/traffic2.vue